import { Injectable } from '@angular/core';
import {
  Router
} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AdminAuthService {

  constructor(private router: Router) {}

  canActivate() {
    const token = localStorage.getItem('api_token');
    if (token && localStorage.getItem('role_type')) {
      return true;
    }
    this.router.navigate(['client-login']);
    return false;
  }
  
}
